import type { ComponentType } from 'react';

import { Address } from './_components/Address';
import { AdminSettings } from './_components/AdminSettings';
import { Connectivity } from './_components/Connectivity';
import { DisplayNames } from './_components/DisplayNames';
import { Identity } from './_components/Identity';

export type GeneralSectionProps = {
  hotelId: number;
};

export type GeneralSection = {
  key: string;
  title: string;
  component: ComponentType<GeneralSectionProps>;
};

export const GENERAL_SECTIONS: GeneralSection[] = [
  { key: 'identity', title: 'Identity', component: Identity },
  { key: 'address', title: 'Address', component: Address },
  { key: 'display-names', title: 'Display names', component: DisplayNames },
  { key: 'connectivity', title: 'Connectivity', component: Connectivity },
  { key: 'admin-settings', title: 'Admin settings', component: AdminSettings },
];
